"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _InventoryConfiguration_1 = require("./_InventoryConfiguration");
exports.PutBucketInventoryConfigurationInput = {
    type: "structure",
    required: ["Bucket", "Id", "InventoryConfiguration"],
    members: {
        Bucket: {
            shape: {
                type: "string"
            },
            location: "uri",
            locationName: "Bucket"
        },
        Id: {
            shape: {
                type: "string"
            },
            location: "querystring",
            locationName: "id"
        },
        InventoryConfiguration: {
            shape: _InventoryConfiguration_1._InventoryConfiguration,
            locationName: "InventoryConfiguration",
            xmlNamespace: {
                uri: "http://s3.amazonaws.com/doc/2006-03-01/"
            }
        }
    },
    payload: "InventoryConfiguration"
};
//# sourceMappingURL=PutBucketInventoryConfigurationInput.js.map